//  パスワードの有効期限切れダイアログ
import React from 'react';
import Dialog from './Dialog';

interface Props {
  okCallback: (event: React.MouseEvent) => void;
  open: boolean;
}
const PasswordExpiredDialog: React.FC<Props> = ({ okCallback, open }) => {
  return (
    <Dialog
      label="パスワードの有効期限切れ"
      body={
        <p>
          パスワードの有効期限が切れています。
          <br />
          パスワードを変更して下さい。
        </p>
      }
      ok={'OK'}
      okCallback={okCallback}
      open={open}
    ></Dialog>
  );
};

export default PasswordExpiredDialog;
